import BaseService from './BaseService';

export default class extends BaseService {
  static index(options = {}) {
    const url = super.url(
      `adulticides/${options.adulticideId}/spray_session_entries`
    );

    if (options.page) {
      url.searchParams.append('page', options.page);
    }

    return super
      .get(url)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        return Promise.reject(error.response.data);
      });
  }
}
